export const scriptKeys = new Set([
  'props.config.customScript',
  'props.config.function.script',
  'script'
]);
